// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Lookup-Body-styles___bodyPaper--rDzCY {
  margin: 40px;
}

.components-Lookup-Body-styles___notFound--NSwBr {
  text-align: center;
  margin: 20px;
  font-size: 18px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}

.components-Lookup-Body-styles___tabs--rnWWe,
.components-Lookup-Body-styles___tab--9sNfc {
  text-transform: initial !important;
}

.components-Lookup-Body-styles___tabs--rnWWe {
  border-bottom: 1px solid #c6c8cc;
  margin-bottom: 40px;
}
`, "",{"version":3,"sources":["webpack://./components/Lookup/Body/styles.pcss"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uDAAuD;AACzD;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB","sourcesContent":[".bodyPaper {\n  margin: 40px;\n}\n\n.notFound {\n  text-align: center;\n  margin: 20px;\n  font-size: 18px;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n  margin-bottom: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyPaper": `components-Lookup-Body-styles___bodyPaper--rDzCY`,
	"notFound": `components-Lookup-Body-styles___notFound--NSwBr`,
	"tabs": `components-Lookup-Body-styles___tabs--rnWWe`,
	"tab": `components-Lookup-Body-styles___tab--9sNfc`
};
module.exports = ___CSS_LOADER_EXPORT___;
